import React, { useState } from "react";
import { Link, useLocation } from 'react-router-dom';

export default function AgenticAICalculator() {
  const [calcType, setCalcType] = useState("subscription");
  const [cost, setCost] = useState(0);
  const [inputText, setInputText] = useState("");
  const [expectedOutputTokens, setExpectedOutputTokens] = useState(0);
  const [showPlans, setShowPlans] = useState(false);

  const aiPurseOpening = Math.floor(Math.random() * 600) + 100; 

  const computeFinalPrice = (base) => {
    if (!base || base <= 0) return 0;
    const marginAdjusted = base / 0.6;
    const bankAdjusted = marginAdjusted / 0.97;
    const finalPrice = bankAdjusted * 1.18;
    return finalPrice;
  };

  const subscriptionResult = computeFinalPrice(Number(cost) || 0).toFixed(2);

  const inputTokens = inputText.length;
  const totalTokens = inputTokens + (Number(expectedOutputTokens) || 0);
  const INTERNAL_COST_PER_1K_TOKENS = 0.5;
  const rawUsageCost = (totalTokens / 1000) * INTERNAL_COST_PER_1K_TOKENS;
  const usageFinalPrice = computeFinalPrice(rawUsageCost);

  const aiPurseClosing = aiPurseOpening - usageFinalPrice;

  return (
    <div className="w-full min-h-screen mx-auto p-4 bg-black text-white border botder-blue-900 rounded-xl shadow-lg space-y-4">
      <h1 className="text-lg lg:text-xl border-b border-blue-400 font-bold text-center py-4">Thinky: Think5Whys Agentic AI Pricing Calculator</h1>
      <div className="grid grid-cols-3 lg:grid-cols-3 justify-center gap-2 text-sm lg:text-m place-items-center">
        <button
          onClick={() => setCalcType("usage")}
          className={`px-3 py-2 rounded-xl min-w-[90px] text-center transition ${calcType === "usage" ? "bg-blue-600" : "bg-gray-700"}`}
        >
          Usage Cost Calculator
        </button>
        <button
          onClick={() => setShowPlans('subscription')}
          className="px-3 py-2 rounded-xl min-w-[90px] text-center bg-emerald-600 transition"
        >
          Subscription Info
        </button>
      </div>

      {showPlans && (
        <div className="bg-black border border-blue-400 p-3 rounded-xl text-xs sm:text-sm space-y-2">
          <h2 className="font-bold text-yellow-200 text-m lg:text-lg">Available Plans</h2>
          <ul className="space-y-1 list-disc pl-4 text-white text-sm lg:text-m">
            <li>Starter: ₹199/month</li>
            <li>Growth: ₹399/month</li>
            <li>Professional: ₹699/month</li>
            <li>Enterprise: ₹1299/month</li>
          </ul>
          <p className="text-sm lg:text-m text-gray-300 mt-1">
            All prices are indicative and include margin, taxes, and payment charges.
          </p>
        </div>
      )}

      {calcType === "subscription" && (
        <div className="space-y-3">
          <h2 className="font-semibold text-yellow-200 text-m lg:text-lg">Subscription Calculator</h2>
          <div className="flex felx-row">
            <label className="w-full text-sm lg:text-m mb-1">Enter your internal monthly cost (₹)</label>
            <input
              type="number"
              className="bg-black p-2 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="e.g., 100"
              value={cost}
              onChange={(e) => setCost(e.target.value)}
              min={0}
            />
          </div>
          <div className="bg-black p-3 rounded-xl flex items-center justify-start gap-4 text-sm">
            <p className="text-sm lg:text-m">Final Customer Price: </p>
            <p className="text-sm lg:text-m font-bold">₹{subscriptionResult}</p>
          </div>
        </div>
      )}

      {calcType === "usage" && (
        <>
          <div className="space-y-3 text-yellow-200 text-m lg:text-lg">
            <h2 className="font-semibold text-m lg:text-lg text-yellow-200">Usage-Based Calculator</h2>
            <div className="space-y-1">
              <label className="block text-sm lg:text-m">Paste or type your input text</label>
              <textarea
                className="w-full bg-gray-800 p-2 rounded-xl text-sm min-h-[120px] resize-y outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="Describe the task, prompt, or data you will send to the AI..."
                value={inputText}
                onChange={(e) => setInputText(e.target.value)}
              />
              <p className="text-sm lg:text-lg text-gray-300">
                Approx. input tokens (characters): <span className="font-semibold">{inputTokens}</span>
              </p>
            </div>

            <div className="flex flex-row justify-start items-start">
              <label className="w-full text-sm lg:text-m">Expected output tokens (approx.)</label>
              <input
                type="number"
                className="bg-gray-800 p-2 rounded-xl text-sm outline-none focus:ring-2 focus:ring-blue-500"
                placeholder="e.g., 300"
                value={expectedOutputTokens}
                onChange={(e) => setExpectedOutputTokens(e.target.value)}
                min={0}
              />
            </div>

            <div className="bg-black p-3 rounded-xl text-sm lg:text-lg space-y-2">
              <div className="flex flex-row gap-4 justify-left">
                <p>Total approx. tokens: </p>
                <p className="font-semibold">{isNaN(totalTokens) ? 0 : totalTokens}</p>
              </div>
              <div className="flex justify-left items-left gap-4 pt-1 border-t border-gray-700 mt-1">
                <p>Tentative cost: </p>
                <p className="text-lg font-bold">₹{isNaN(usageFinalPrice) ? "0.00" : usageFinalPrice.toFixed(2)}</p>
              </div>

              <div className="bg-black p-3 rounded-xl border border-gray-700 space-y-1">
                <h3 className="text-sm font-semibold text-yellow-200">Your Think5Whys AI Purse</h3>
                <p>Opening Balance: <span className="font-bold text-green-400">₹{aiPurseOpening.toFixed(2)}</span></p>
                <p>Estimated Debit: <span className="font-bold text-red-400">₹{usageFinalPrice.toFixed(2)}</span></p>
                <p>Closing Balance: <span className={`font-bold ${aiPurseClosing >= 0 ? "text-green-300" : "text-red-300"}`}>₹{aiPurseClosing.toFixed(2)}</span></p>

                {aiPurseClosing < 0 && (
                  <button className="mt-2 w-full bg-blue-600 text-white py-2 rounded-xl hover:bg-blue-700 transition">
                    Add Balance
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      <footer className="sticky bg-black border-t border-blue-400 text-white py-2 px-4 mt-2">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left space-y-4 md:space-y-0">
          <p className="text-xs sm:text-sm">&copy; 2025 Think5Whys Global DeepTech Solutions.</p>
          <div className="flex flex-wrap justify-center md:justify-start gap-2 sm:gap-6 text-xs sm:text-sm">
            <Link to="/about-us" className="text-white hover:text-purple-200 transition">About</Link>
            <Link to="/privacy-policy" className="text-white hover:text-purple-200 transition">Privacy Policy</Link>
            <Link to="/terms-of-use" className="text-white hover:text-purple-200 transition">Terms of Use</Link>
            <Link to="/contact-us" className="text-white hover:text-purple-200 transition">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
